import Snackbar from '@mui/material/Snackbar';
import { forwardRef, useImperativeHandle, useState } from 'react';
import Alert from '@mui/material/Alert';

const ResponseSnackbar = (_, ref) => {
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState({});

  useImperativeHandle(ref, () => ({
    open: (res) => {
      setDetails(res);
      setOpen(false);
      requestAnimationFrame(() => setOpen(true));
    },
  }));

  const onClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={details.autoHideDuration || 3000}
      onClose={onClose}
    >
      <Alert severity={details.status} sx={{ width: '100%' }}>
        {details.message}
      </Alert>
    </Snackbar>
  );
};

export default forwardRef(ResponseSnackbar);
